import React from 'react'

export default function Hero() {
	return (
		<>
			<a
				style={{
					transform:
						'translate3d(0%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
					transformStyle: 'preserve-3d',
				}}
				href="#"
				target="_blank"
				className="fixed-button blog w-inline-block ">
				<div className="text-block _1 sidebar-text">twitter</div>
			</a>

			<a
				href="#"
				className="fixed-button timer w-inline-block"
				style={{
					transform:
						'translate3d(0%, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
					transformStyle: 'preserve-3d',
				}}>
				<div className="text-block text-lowercase sidebar-text">discord</div>
			</a>
			<div className="hero">
				<div className="container-main relative w-container">
					<div className="hero-text">
						<h1 className="h1">
							METAMATES APE LOUNGE <br /> 5K NFT
						</h1>
						<p className="p1 hero-p">
							METAMATES APE LOUNGE 5k NFT collection is a limited collection of
							5,000 unique 3D NFTs with many attributes inspired from many
							existing ape projects captured on Ethereum and Solana blockchain.
							Also the apes will start to coexist through metaverse games. This
							project is going to serve a cause where part of the funds to be
							donated to Ukraine war heroes &amp; families through legitimate
							channels.
							<br />
						</p>
						<div className="button-wrap">
							<a href="#" target="_blank" className="hero-cta margin w-button">
								buy on rarible
							</a>
							<a href="#" target="_blank" className="hero-cta margin w-button">
								buy on opensea
							</a>
							<a href="#" target="_blank" className="hero-cta margin w-button">
								buy on mintable
							</a>
						</div>
					</div>
				</div>
				<div className="hero-cta-wrap">
					<div className="container-main w-container"></div>
				</div>
			</div>
		</>
	)
}
